<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
      <span slot="button"  v-if="permissionChecker('User.Create')">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span>
    </filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
    >
      <template slot="selfactions" slot-scope="rowKey">
        <span>
            <a href="javascript:;" @click="handleEdit(2,rowKey.data)">详情</a>
             <a-divider type="vertical"/>
                  <a-dropdown>
                    <a class="ant-dropdown-link">更多
                        <a-icon type="down"/>
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                          <a href="javascript:;" @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('User.Edit')">编辑</a>
                        </a-menu-item>
                        <a-menu-item>
                       <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="!permissionChecker('User.Delete')">删除</a>
                        </a-menu-item>
                         <a-menu-item>
                       <a href="javascript:;" @click="resetPassword(rowKey.data)"  :disabled="!permissionChecker('User.Edit')">重置密码</a>
                        </a-menu-item>
                    </a-menu>
                    </a-dropdown>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch  :disabled="!permissionChecker('User.Edit')" v-model="rowKey.data.isActive" @change="activeChange(rowKey.data)"/>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-user-add
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="addVisible = false"
        :params="params"
      ></hp-manager-page-user-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageUserAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {

    hpManagerPageUserAdd
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "姓名"
        },
       {
          type: "input",
          key: "userName",
          name: "账号"
        },
          {
          type: "input",
          key: "phoneNumber",
          name: "联系方式"
        },
        {
          type: "select",
          key: "isActive",
          name: "状态",
          options: [{ name: "启用", val: 1 }, { name: "禁用", val: 0 }]
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: "10%",
          scopedSlots: { customRender: "action" }
        },
        {
          title: "帐号",
          width: "15%",
          dataIndex: "userName",
          sorter: true,
        },
        {
          title: " 姓名",
          width: 150,
          dataIndex: "name",
          width: "15%",
          sorter: true
        },
        {
          title: " 联系方式",
          width: 150,
          dataIndex: "phoneNumber",
          width: "15%",
          sorter: true
        },
              {
          title: " 角色",
          width: 150,
          dataIndex: "roleNames",
          width: "15%",
          sorter: true
        },
                {
          title: " 最后登录时间",
          width: 150,
          dataIndex: "lastLoginTime",
          width: "15%",
          sorter: true,
           customRender: (text, row, index) => {
            return (row.lastLoginTime != null
              ? this.formatDate(row.lastLoginTime, "YYYY-MM-DD HH:mm:ss"):"");
           }
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          width: "15%",
          customRender: (text, row, index) => {
            return (row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss"));
          }
        },
        {
          title: "状态",
          width: "10%",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", userName: "", phoneNumber: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      title:""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
     let a =this.getPermission()
    console.log(a)
  },
  methods: {
        handleSubmit(p) {
      this.pagination.current=0;  
      this.filterdata.name = p.values.name;
      this.filterdata.userName = p.values.userName;
        this.filterdata.phoneNumber = p.values.phoneNumber;
      this.filterdata.isActive =
        p.values.isActive == 1 ? true : p.values.isActive == 0 ? false : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async activeChange(record) {
      let active = await api.ActiveUser({ id: record.id });
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑";
      } else if (type == 2) {
        this.title = "详情";
        this.isabl = true;
      } else {
        this.title = "新增";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelUser({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },
    async resetPassword(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要将此用户密码重置为123456?",
          okText: "重置",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.resetPasswordHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async resetPasswordHandle(row) {
      let msgRet = await api.ResetPassword({ id: row.id });
      if (msgRet) {
        this.$message.success("重置成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },
    refreshCurrent() {this.pagination.current=0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetUserList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Admins/User/List.vue